import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
  import { navigateToUrl } from 'single-spa';
  import { useUserStore } from '@/lib/stores';
  import { onBoardingService } from '@/lib/services/onBoardingService';

  
export default /*@__PURE__*/_defineComponent({
  __name: 'NavigationMenu',
  setup(__props, { expose: __expose }) {
  __expose();

  const ONBOARDING_PRODUCTS = ['marketing', 'service', 'commerce'] as const;

  const userStore = useUserStore();

  const isCollapsed = computed(() => userStore.isNavigationRail);

  const progressCircularBind = computed(() => ({
    modelValue: onBoardingService.getOnboardingCompletedPercentage.value ?? 0,
    size: 22,
    width: 3,
    color: 'mpBlue',
    bgColor: 'grey',
  }));

  const completedStepsDisplay = computed(
    () => onBoardingService.getOnboardingCompletedSteps.value ?? 0,
  );

  const totalStepsDisplay = computed(
    () => onBoardingService.getOnboardingTotalSteps.value ?? 0,
  );

  const isOnboardingAvailable = computed(() => {
    const hasAccess = ONBOARDING_PRODUCTS.some((product) =>
      userStore.getProductAccess(product),
    );
    return hasAccess && !onBoardingService.isOnboardingCompleted.value;
  });

  function openOnboarding() {
    navigateToUrl(`/accounts/${userStore.getAccountId}/onboarding`);
  }

const __returned__ = { ONBOARDING_PRODUCTS, userStore, isCollapsed, progressCircularBind, completedStepsDisplay, totalStepsDisplay, isOnboardingAvailable, openOnboarding }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})